/**
 * Rotating brand-panel sentences for the Guestmaker login shell.
 * Order matters: index 0 is the anchor line shown when motion is reduced
 * or the viewport is narrow. Edit copy here only.
 * Keep every sentence ≤ 64 characters (proofs.test.ts): about 3 lines in
 * the panel; see .bs-proofs in src/brands/base/base.css.
 */
export const GUESTMAKER_PROOFS: readonly string[] = [
  "The omnichannel AI CRM that remembers every guest.",
  "Every WhatsApp answered in the guest's language, in seconds.",
  "An AI concierge that checks availability and books the stay.",
  "Every guest request routed to the right team, automatically.",
  "The favourite room, the allergy, the anniversary. Remembered.",
  "Pre-arrival to post-stay. WhatsApp and email in one journey.",
  "Email campaigns from the same guest data and the same AI.",
  "Segments by stay, loyalty tier or last conversation.",
  "Loyalty inside your own booking flow, not a third-party app.",
  "Fifty hotels, fifty PMS systems, one guest profile.",
  "Phone calls answered by an AI that speaks ninety languages.",
  "A WhatsApp price question becomes a confirmed booking.",
  "One knowledge base for the group, one per hotel.",
  "One guest, one memory, every channel.",
];
